import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Pagination from "@mui/material/Pagination";
import classes from "../activities/Activities.module.css";
import { testUrl } from "../BaseData";

const CategoryActivities = () => {
    const navigate = useNavigate();
    const { dep_name, short_name } = useParams();
    const { t, i18n } = useTranslation();

    const [categoryActivity, setCategoryActivity] = useState(null);
    const [category, setCategory] = useState(null);
    const [department, setDepartment] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [backendSidebarData, setBackendSidebarData] = useState([]);
    const [pageApi, setPageApi] = useState(1);

    const itemsPerPage = 9;

    useEffect(() => {
        setLoading(true);
        setError(null);
        setCategoryActivity(null);
        setCategory(null);
        setDepartment(null);

        const fetchCategoryActivityData = axios.get(
            testUrl + `/api/activities/${dep_name}/${short_name}`
        );

        const fetchBackendSidebarData = axios.get(
            testUrl + "/api/activitiescategory/"
        );

        Promise.all([fetchCategoryActivityData, fetchBackendSidebarData])
            .then(([activityResponse, sidebarResponse]) => {
                const activity = activityResponse.data;
                if (activity) {
                    setCategoryActivity(activity);
                    setCategory(activity?.category || null);
                    setDepartment(activity?.department || null);
                } else {
                    setError(t("Ma'lumotlar topilmadi"));
                }

                if (sidebarResponse.data) {
                    setBackendSidebarData(sidebarResponse.data);
                }
            })
            .catch((err) => {
                if (err.response && err.response.status === 404) {
                    setError(t("Hozircha ma'lumot kiritilmagan"));
                } else {
                    setError(t("Ma'lumotlarni yuklashda xatolik"));
                }
            })
            .finally(() => setLoading(false));

    }, [dep_name, short_name, i18n.language]);

    const getDepartmentName = (item) => {
        if (!item) return t("no_name_available");
        const title = item[`name_${i18n.language}`];
        return title || item.name_uz || t("no_name_available");
    };

    if (loading) return <div style={{ textAlign: 'center', padding: '100px' }}>{t("Yuklanmoqda...")}</div>;

    const posts = categoryActivity?.posts || [];
    const indexOfLastItem = pageApi * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPosts = posts.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div className={classes.mainContainer}>
            <div data-aos="fade-up" className={classes.container}>
                <h1 className={classes["page-title"]}>
                    {category?.[`name_${i18n.language}`] || (error ? t("Ma'lumot topilmadi") : "")}
                </h1>

                {error ? (
                    <p style={{ textAlign: 'center', marginTop: '50px', color: '#666' }}>{error}</p>
                ) : (
                    <>
                        {/* Render raw content if it exists */}
                        {categoryActivity?.[`content_${i18n.language}`] && (
                            <div
                                style={{ marginBottom: '40px' }}
                                dangerouslySetInnerHTML={{
                                    __html: categoryActivity[`content_${i18n.language}`],
                                }}
                            />
                        )}

                        {/* Render Gallery of Posts */}
                        {posts.length > 0 && (
                            <div className={classes.gallery}>
                                {currentPosts.map((item) => (
                                    <div
                                        key={item.id}
                                        className={classes["gallery-item"]}
                                        onClick={() => navigate(`/department-activity-detail/${item.id}`)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <img
                                            src={item.image || './media/activities/activity.jpeg'}
                                            alt={item[`name_${i18n.language}`]}
                                            className={classes["gallery-image"]}
                                        />
                                        <div className={classes["gallery-text"]}>
                                            {item[`name_${i18n.language}`] || item.name_uz}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {posts.length > itemsPerPage && (
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
                                <Pagination
                                    count={Math.ceil(posts.length / itemsPerPage)}
                                    page={pageApi}
                                    onChange={(e, value) => {
                                        setPageApi(value);
                                        window.scrollTo(0, 0);
                                    }}
                                    variant="outlined"
                                    color="primary"
                                    shape="rounded"
                                />
                            </div>
                        )}
                    </>
                )}
            </div>

            <div className={classes.sidebar}>
                <h3>
                    {department ? getDepartmentName(department) : t("Kafedra")}
                </h3>
                <ul>
                    {backendSidebarData.map((item) => (
                        <li
                            onClick={() => navigate(`/activities/${dep_name}/${item.short_name}/`)}
                            key={item.id}
                            className={item.short_name === short_name ? classes.active : ''}
                        >
                            <span style={{ cursor: 'pointer' }}>
                                {getDepartmentName(item)}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default CategoryActivities;
